import NavigateToPageTemplate from 'Views/Page/Content/RightSidebar/Content/Templates/NavigateToPageTemplate';
import PerformanceCommentaryTemplate
  from 'Views/Page/Content/RightSidebar/Content/Templates/PerformanceCommentaryTemplate/PerformanceCommentaryTemplate';
import HistoryTemplate from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate/RightSideBar/HistoryTemplate';
import RoadmapExplorerLeversTemplate from './RoadmapExplorerLevers';
import DefaultTemplate from './DefaultTemplate';

export const templateMap = {
  facetPlanView: NavigateToPageTemplate, // facetPlanview is the entire what if feature, it only fits on the entire page.
  facetPlanProposalPreview: NavigateToPageTemplate, // FacetPlanProposalPreview is the what if proposal page. It is a desktop design that is much too large for a modal.
  facetPlanProposalNextUpReviewPage: NavigateToPageTemplate,
  PerformanceCommentary: PerformanceCommentaryTemplate, // we are rendering a preview of what the performance commentary will look like as its being edited
  facetPlanProposalScenarioInsightSection: HistoryTemplate, // we are rendering a readonly accordion meta collection form with pagination
  RoadmapExplorerLevers: RoadmapExplorerLeversTemplate,

  // Only add to here if both of the following conditions are true:
  // 1. You are not able to improve the default template to display the design you need to display
  // 2. Your design can not be adjusted to something that can conform to the default layout.
  // Please drop a quick comment explaining why the new template was necessary if you do this
};

export default function useTemplate(coll) {
  if (coll) {
    const Template = templateMap[coll.meta().type()];
    if (Template) return Template;

    return DefaultTemplate;
  }

  // Return nothing if you have no data
  return null;
}
